import { useTranslation } from "react-i18next";

export default function SuggestedDrink(props) {
    const { product } = props;

    const { t } = useTranslation();

    return (
        <div className="suggested-drink py-1 px-3 text-sm bg-grey-400">
            <p><span className="font-bold">{t("suggesteddrink.p_1")}</span> {product.suggested_drink.name}</p>
        </div>
    );
}
